module.exports = __webpack_public_path__ + "media/images/logo_navbar-cb999bb39df2403ef808e4200cbe8e79.png";